import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiError, firstVisiblePath } from "../context/AuthContext";
import { Compass, SignIn } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { PasswordInput } from "../components/PasswordInput";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { user, perms } = await login(email.trim(), password);
      const isMgr = user && (user.role === "Admin" || user.role === "Managing Director");
      navigate(firstVisiblePath(perms, isMgr));
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="h-14 w-14 rounded-xl bg-primary flex items-center justify-center text-primary-foreground mb-4">
            <Compass weight="duotone" size={30} />
          </div>
          <h1 className="font-display font-bold text-2xl tracking-tight text-center">DAA Project Management System</h1>
          <p className="text-sm text-muted-foreground mt-1.5">Sign in to your team account</p>
        </div>
        <form onSubmit={submit} className="rounded-xl border border-border bg-card p-8 space-y-5 shadow-sm">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value.toLowerCase())}
              placeholder="you@daa.com" autoComplete="username" required data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <PasswordInput id="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" autoComplete="current-password" required data-testid="login-password" />
          </div>
          {error && <div className="text-sm text-red-500 bg-red-500/10 border border-red-500/30 rounded-md px-3 py-2" data-testid="login-error">{error}</div>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
            <SignIn size={16} className="mr-2" />{loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <p className="text-center text-xs text-muted-foreground mt-6">Contact your Admin if you need an account.</p>
      </div>
    </div>
  );
}
